
//export const API_URL=process.env.API_URL_VARIABLE;
export const API_URL=''